export const NUMERIC_PATTERNS = {
    INTEGER: String.raw`^\d+$`,
    MONEY: String.raw`^\d+(\.\d{0,2})?$`,
    PERCENTAGE_4: String.raw`^\d+(\.\d{0,4})?$`,
    DECIMAL: String.raw`^\d+(\.\d*)?$`,
    SIGNED_DECIMAL: String.raw`^-?\d+(\.\d*)?$`,
    SIGNED_MONEY: String.raw`^-?\d+(\.\d{0,2})?$`,
} as const;

export function discountInputPattern(discountType: 'percentage' | 'flat'): string {
    return discountType === 'flat' ? NUMERIC_PATTERNS.MONEY : NUMERIC_PATTERNS.PERCENTAGE_4;
}
